import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ fontSize: number | undefined }>()((theme, { fontSize }) => ({
  incompleteStatusBanner: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      fontSize: getFontSize(fontSize, true)
    },
    textAlign: 'center',
    padding: '0px 1px',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    backgroundColor: '#C84240',
    color: '#E8EBF4',
    ...{ fontSize: getFontSize(fontSize) }
  }
}));

const getFontSize = (fontSize: number | undefined, mobile?: boolean) => {
  if (fontSize) {
    return fontSize;
  }
  if (mobile) {
    return 8;
  }
  return 10;
};
